export default "__VITE_ASSET__DLP_Q3QX__"